import script from "./menu-settings.vue?vue&type=script&setup=true&lang=js"
export * from "./menu-settings.vue?vue&type=script&setup=true&lang=js"

import "./menu-settings.vue?vue&type=style&index=0&id=239b3e08&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-239b3e08"]])

export default __exports__